/**
 * Previously, customer data (including personal information such as name, email, phone number,
 * and addresses) was stored in localStorage after a purchase was completed. This posed a significant
 * GDPR risk and data privacy concern, especially on shared computers where subsequent users could
 * see previous purchasers' personal details. We now actively clear any existing customer data from
 * localStorage.
 *
 * DO NOT REMOVE: This cleanup code should remain permanently to handle legacy data.
 */
const localStorageKey = 'stickerapp.checkout.customer';
export const clearCustomerDataFromLocalStorage = () => {
    try {
        localStorage.removeItem(localStorageKey);
    }
    catch (_a) {
        // Silently fail if localStorage is not available (e.g., private browsing mode)
    }
};
//# sourceMappingURL=customer.js.map